import { useContext, useEffect } from "react";
import { Table } from "react-bootstrap";
import { isEmpty } from "lodash";
import { useLocation } from "react-router-dom";
import { DateInput } from "react-hichestan-datetimepicker";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../utils/Breadcrumbs/Breadcrumbs";
import SiteTitle from "../../../utils/SiteTitle/SiteTitle";
import EmptyData from "../../../utils/EmptyData/EmptyData";
import CardLayout from "../../../utils/CardLayout/CardLayout";
import PaginationList from "../../../utils/PaginationList/PaginationList";
import CustomModal from "./../../../utils/CustomModal/CustomModal";
import TooltipTitle from "../../../utils/TooltipTitle/TooltipTitle";
import Animations from "../../../utils/Animations";
import {
  convertDate,
  dialogContainerStyle,
  numberSeparate,
} from "../../../utils";
import { failureRequestsAdminContext } from "../../../context/Admin/FailureRequestsAdminContext/FailureRequestsAdminContext";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";

const FailureRequestsAdmin = () => {
  const permission = useSelector((state) => state.permission);

  const { pathname } = useLocation();

  const {
    failureRequests,
    failureRequest,
    search,
    setSearch,
    to_date,
    setTo_date,
    from_date,
    setFrom_date,
    status,
    setStatus,
    limit,
    setLimit,
    totalCount,
    pageNumber,
    setPageNumber,
    isShowAdvancedSearch,
    setIsShowAdvancedSearch,
    handleGetFailureRequests,
    handleGetFailureRequest,
    handleDeleteFailureRequest,
    handleCloseFailureRequestModal,
    handleDateRange,
    city_filter,
    setCity_filter,
    cities,
  } = useContext(failureRequestsAdminContext);

  useEffect(() => {
    handleGetFailureRequests();
  }, [pageNumber, limit, status]);

  const onNavigate = (pk) => {
    window.open(
      `${pathname?.replace("FailureRequests", "Orders")}/${pk}`,
      "_blank"
    );
  };

  return (
    <>
      <SiteTitle title="درخواست ها" />
      <Breadcrumbs
        navs={[
          { name: "داشبورد", url: "/Admin/Dashboard", type: "l" },
          { name: "درخواست ها", type: "a" },
        ]}
        title="لیست درخواست ها"
      />

      <CardLayout>
        <div className="mb-2">
          <button
            onClick={() => setIsShowAdvancedSearch(!isShowAdvancedSearch)}
            className={`btn btn-${
              isShowAdvancedSearch ? "" : "outline-"
            }primary mr-2`}
          >
            جستجو پیشرفته
          </button>
        </div>
        <form className="input-group mb-3" onSubmit={handleGetFailureRequests}>
          <input
            type="text"
            name="search"
            autoComplete="off"
            placeholder="جستجو ..."
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="input-group-append">
            <button type="submit" className="btn btn-primary">
              جستجو
            </button>
          </div>
        </form>
        {isShowAdvancedSearch && (
          <Animations name="fadeIn">
            <div className="row">
              <div className="col-12 mb-2">
                <div className="btn-group">
                  {[3, 7, 30, 60, 90, 120, 180, 365].map((item) => (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => handleDateRange(item)}
                    >
                      {item} روز اخیر
                    </button>
                  ))}
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="وضعیت">
                  <select
                    className="form-control mb-3"
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <option value="" selected={"" === status}>
                      وضعیت: همه
                    </option>
                    <option value="True" selected={"True" === status}>
                      خاتمه یافته
                    </option>
                    <option value="False" selected={"False" === status}>
                      خاتمه نیافته
                    </option>
                  </select>
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                  <select
                    className="form-control"
                    onChange={(e) => setCity_filter(e.target.value)}
                    value={city_filter}
                  >
                    <option value="" selected={city_filter === ""}>
                      همه شهرها
                    </option>
                    {cities?.map((item) => (
                      <option key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="از تاریخ">
                  <DateInput
                    id="from_date"
                    value={from_date}
                    className="form-control"
                    name="from_date"
                    onChange={(e) => setFrom_date(e.target.value)}
                    autoOk="false"
                    placeholder="از تاریخ"
                    dialogContainerStyle={dialogContainerStyle}
                  />
                </TooltipTitle>
              </div>
              <div className="col-12 col-md-6 col-lg-3 mb-2">
                <TooltipTitle title="تا تاریخ">
                  <DateInput
                    id="to_date"
                    value={to_date}
                    className="form-control"
                    name="to_date"
                    onChange={(e) => setTo_date(e.target.value)}
                    autoOk="false"
                    placeholder="تا تاریخ"
                    dialogContainerStyle={dialogContainerStyle}
                  />
                </TooltipTitle>
              </div>
            </div>
          </Animations>
        )}
        {isEmpty(failureRequests) ? (
          <EmptyData />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <PaginationList
                setPageNumber={setPageNumber}
                pageCount={totalCount / limit}
              />
              <div>
                <select
                  className="form-control mb-3"
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                  <option value={10} selected={10 === limit}>
                    10
                  </option>
                  <option value={25} selected={25 === limit}>
                    25
                  </option>
                  <option value={50} selected={50 === limit}>
                    50
                  </option>
                  <option value={75} selected={75 === limit}>
                    75
                  </option>
                  <option value={100} selected={100 === limit}>
                    100
                  </option>
                </select>
              </div>
            </div>
            <Table
              responsive
              hover
              borderless
              striped
              className="scrollable-table"
            >
              <thead className="thead-dark text-center">
                <tr>
                  <th>#</th>
                  <th>مشتری</th>
                  <th>سازمان مشتری</th>
                  <th>کد پیگیری سفارش</th>
                  <th>تاریخ درخواست</th>
                  <th>تاریخ ثبت سفارش</th>
                  <th>تاریخ نهایی</th>
                  <th>ثبت تا درخواست</th>
                  <th>چند روزه حل شد</th>
                  <th>نوع درخواست</th>
                  <th>شماره تماس کاربر</th>
                  <th>پرسنل</th>
                  {/* <th>نتیجه نهایی</th> */}
                  {/* <th>چطوری راضیش کردم؟</th> */}
                  <th className="text-center">
                    تعداد کل :{" "}
                    <span className="badge badge-primary font-weight-bold p-1">
                      {totalCount}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody className="text-center">
                {failureRequests.map((_item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>
                      <TooltipTitle
                        title={_item?.order?.client?.mobile}
                        placement="bottom"
                      >
                        <span>
                          {_item?.order?.client?.first_name}{" "}
                          {_item?.order?.client?.last_name}
                        </span>
                      </TooltipTitle>
                    </td>
                    <td>
                      {_item?.order?.client?.employer ? (
                        <span className="badge badge-primary font-weight-bold">
                          {_item?.order?.client?.employer?.name}
                        </span>
                      ) : (
                        <span className="badge badge-secondary font-weight-bold">
                          کاربر عادی
                        </span>
                      )}
                    </td>
                    <td>{_item?.order?.ref_num}</td>
                    <td>{convertDate(_item?.created, "DD MMM ساعت HH")}</td>
                    <td>
                      {convertDate(_item?.order?.created, "DD MMM ساعت HH")}
                    </td>
                    <td>{_item?.end_date}</td>
                    <td>{numberSeparate(_item?.until_created)} روز</td>
                    <td>{numberSeparate(_item?.until_solved)}</td>
                    <td>{_item?.request_type?.description}</td>
                    <td>{_item?.order?.client?.mobile}</td>
                    <td>
                      {!isEmpty(_item?.order?.personnel) &&
                        _item?.order?.personnel?.map((_personnelVal, index) => (
                          <span
                            className={`d-block ${
                              index + 1 !== _item?.order?.personnel?.length
                                ? "border-bottom"
                                : ""
                            }`}
                          >
                            <TooltipTitle
                              title={_personnelVal?.mobile ?? "ندارد"}
                              placement="bottom"
                            >
                              <span className="mx-1">
                                {_personnelVal?.first_name}{" "}
                                {_personnelVal?.last_name}
                              </span>
                            </TooltipTitle>
                          </span>
                        ))}
                    </td>
                    {/* <td>{_item?.result}</td>
                    <td>{_item?.customer_satisfaction_item?.description}</td> */}
                    <td>
                      <button
                        onClick={() => onNavigate(_item?.order?.pk)}
                        className="btn btn-primary mr-2"
                        disabled={!_item?.order?.pk}
                      >
                        سفارش
                      </button>
                      <button
                        onClick={() => handleGetFailureRequest(_item?.id)}
                        className="btn btn-info mr-2"
                      >
                        نظرات
                      </button>
                      {permission.failure_request_delete && (
                        <i
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteFailureRequest(_item),
                              `آیا از حذف درخواست ${_item?.client?.first_name} ${_item?.client?.last_name} اطمینان دارید؟`
                            )
                          }
                          className="fa fa-trash-alt fa-2x text-danger cursorPointer"
                        />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </>
        )}
      </CardLayout>

      {/* Start Details Modal */}
      <CustomModal
        title="جزئیات پرداخت"
        show={!isEmpty(failureRequest)}
        onHide={handleCloseFailureRequestModal}
        size="xl"
      >
        {isEmpty(failureRequest?.comment) ? (
          <EmptyData />
        ) : (
          <Table hover borderless striped>
            <thead className="thead-dark">
              <tr>
                <th>#</th>
                <th>توضیحات پشتیبانی و امور متخصصین</th>
                <th>پشتیبان</th>
                <th>تاریخ ایجاد</th>
              </tr>
            </thead>
            <tbody>
              {failureRequest?.comment?.map((_item, index) => (
                <tr key={_item.id}>
                  <td>{index + 1}</td>
                  <td>{_item?.comment}</td>
                  <td>
                    {_item?.user?.first_name} {_item?.user?.last_name}
                  </td>
                  <td>{convertDate(_item.created)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CustomModal>
      {/* End Details Modal */}
    </>
  );
};

export default FailureRequestsAdmin;
